import { render, staticRenderFns } from "./ShuffleButtonLottie.vue?vue&type=template&id=2ca35a01&scoped=true"
import script from "./ShuffleButtonLottie.vue?vue&type=script&lang=js"
export * from "./ShuffleButtonLottie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca35a01",
  null
  
)

export default component.exports